var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestoreGuidePencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5598_59130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82931 3.32497C7.59068 3.08634 7.16113 3.08634 6.9225 3.32497L1.6725 8.57497C1.60886 8.63861 1.54522 8.73406 1.51341 8.81361L0.0338596 13.1568C-0.0456859 13.3795 0.0179505 13.6341 0.192951 13.8091C0.320223 13.9364 0.479314 14 0.638405 14C0.702041 14 0.781587 13.9841 0.845223 13.9682L5.18841 12.4886C5.28386 12.4568 5.36341 12.4091 5.42704 12.3295L10.677 7.07953C10.9316 6.82499 10.9316 6.42727 10.677 6.17272L7.82931 3.32497ZM4.6475 11.3273L1.6725 12.3455L2.69068 9.37043L7.38386 4.67725L9.34068 6.63407L4.6475 11.3273Z",
    fill: "#42526E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2385 0.77953C12.7294 0.270439 12.0612 0 11.3612 0C10.6453 0 9.97714 0.270439 9.48395 0.77953L8.29077 1.97271L12.0453 5.7432L13.2385 4.55002C14.2726 3.50002 14.2726 1.81362 13.2385 0.77953Z",
    fill: "#42526E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5598_59130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.014,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreGuidePencilIcon);
export default __webpack_public_path__ + "static/media/RestoreGuide-PencilIcon.32d7c05cee9b0b84868adc042189998b.svg";
export { ForwardRef as ReactComponent };